import React, { useEffect, useState } from 'react';
import Card from '../../components/ui/Card';
import Btn from '../../components/ui/Btn';
import IconBtn from '../../components/ui/IconBtn';
import Badge from '../../components/ui/Badge';
import Secao from '../../components/ui/Secao';
import { pedidosApi } from '../../api/vendas';
import { STATUS_TOM, STATUS_LABEL } from '../vendas/PedidoDetail';
import { COLORS } from '../../theme';
import { useTituloPagina } from '../../context/PageTitleContext';
import { useAuth } from '../../context/AuthContext';

function diasEmAberto(criadoEm) {
  const ms = Date.now() - new Date(criadoEm).getTime();
  return Math.max(Math.floor(ms / (1000 * 60 * 60 * 24)), 0);
}

export default function SeparacaoDetail({ pedidoId, onVoltar }) {
  const { empresaAtual } = useAuth();
  const [pedido, setPedido] = useState(null);
  const [processando, setProcessando] = useState(false);
  const [erro, setErro] = useState('');
  const [devolvendo, setDevolvendo] = useState(false);
  const [motivoDevolucao, setMotivoDevolucao] = useState('');

  const carregar = () => pedidosApi.obter(pedidoId).then(setPedido).catch(() => {});
  useEffect(() => { carregar(); }, [pedidoId]); // eslint-disable-line

  useTituloPagina(pedido ? `Separação — Pedido #${pedido.numero}` : 'Separação');

  const imprimir = async (marcarComoEmSeparacao) => {
    const janela = window.open('', '_blank');
    janela.document.write(`<!DOCTYPE html><html><head><title>Separação — Pedido #${pedido.numero}</title>
      <meta charset="utf-8" />
      <style>
        body { font-family: Arial, sans-serif; color: #0f172a; padding: 24px; }
        h2 { margin: 0; font-size: 18px; }
        h3 { font-size: 13px; margin-bottom: 6px; }
        table { width: 100%; border-collapse: collapse; font-size: 13px; margin-bottom: 16px; }
        th { text-align: left; border-bottom: 1.5px solid #000; padding: 6px; }
        td { padding: 8px 6px; border-bottom: 1px solid #ccc; }
        .cabecalho { display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 2px solid #000; padding-bottom: 12px; margin-bottom: 16px; }
        .direita { text-align: right; }
        .bloco { font-size: 12px; margin-bottom: 16px; line-height: 1.6; }
        .check { width: 26px; text-align: center; }
      </style>
      </head><body>
      <div class="cabecalho">
        <div style="display:flex; align-items:flex-start; gap:12px;">
          ${empresaAtual?.logo_url ? `<img src="${window.location.origin}${empresaAtual.logo_url}" alt="Logo" style="max-width:90px; max-height:70px; object-fit:contain;" />` : ''}
          <div>
            <h2>${empresaAtual?.nome || 'Empresa'}</h2>
            <div style="font-size:12px;font-weight:700;margin-top:4px">LISTA DE SEPARAÇÃO</div>
          </div>
        </div>
        <div class="direita">
          <h2>Pedido #${pedido.numero}</h2>
          <div style="font-size:12px">Proposta: ${pedido.proposta_numero ? `#${pedido.proposta_numero}` : '-'}</div>
          <div style="font-size:12px">Data: ${new Date(pedido.criado_em).toLocaleDateString('pt-BR')}</div>
        </div>
      </div>

      <h3>Cliente</h3>
      <div class="bloco">
        <div><strong>${pedido.cliente_nome}</strong></div>
        <div>${pedido.entrega_logradouro || ''}${pedido.entrega_numero ? `, ${pedido.entrega_numero}` : ''}${pedido.entrega_bairro ? ` — ${pedido.entrega_bairro}` : ''}${pedido.entrega_cidade ? `, ${pedido.entrega_cidade}` : ''}${pedido.entrega_uf ? `/${pedido.entrega_uf}` : ''}</div>
        <div>Frete: ${pedido.tipo_frete === 'cif' ? `CIF${pedido.entrega_propria ? ' — Entrega Própria' : pedido.transportadora_nome ? ` — ${pedido.transportadora_nome}` : ''}` : 'FOB'}</div>
      </div>

      <h3>Itens a Separar</h3>
      <table>
        <thead><tr><th class="check">✓</th><th>Código</th><th>Cód. Fabricante</th><th>Produto</th><th>Quantidade</th></tr></thead>
        <tbody>
          ${pedido.itens.map(item => `<tr>
            <td class="check">☐</td>
            <td>${item.produto_codigo}</td>
            <td>${item.produto_codigo_fabricante || '-'}</td>
            <td>${item.produto_nome}</td>
            <td><strong>${item.quantidade}</strong></td>
          </tr>`).join('')}
        </tbody>
      </table>

      ${pedido.observacoes ? `<h3>Observações</h3><p style="font-size:12px">${pedido.observacoes}</p>` : ''}
      </body></html>`);
    janela.document.close();
    janela.onload = () => { janela.focus(); janela.print(); };

    if (marcarComoEmSeparacao) {
      try { await pedidosApi.separar(pedidoId); carregar(); } catch (e) { /* já pode estar em separação */ }
    }
  };

  const iniciarSeparacao = async () => {
    setProcessando(true);
    setErro('');
    try {
      await pedidosApi.separar(pedidoId);
      carregar();
    } catch (e) {
      setErro(e.message);
    } finally {
      setProcessando(false);
    }
  };

  const concluirSeparacao = async () => {
    if (!window.confirm('Confirmar que a separação desse pedido foi concluída?')) return;
    setProcessando(true);
    setErro('');
    try {
      await pedidosApi.concluirSeparacao(pedidoId);
      carregar();
    } catch (e) {
      setErro(e.message);
    } finally {
      setProcessando(false);
    }
  };

  const confirmarDevolucao = async () => {
    if (!motivoDevolucao.trim()) { setErro('Informe o motivo da devolução'); return; }
    setProcessando(true);
    setErro('');
    try {
      await pedidosApi.devolver(pedidoId, motivoDevolucao.trim());
      setDevolvendo(false);
      setMotivoDevolucao('');
      carregar();
    } catch (e) {
      setErro(e.message);
    } finally {
      setProcessando(false);
    }
  };

  if (!pedido) return null;

  const totalGeral = pedido.itens.reduce((s, i) => s + Number(i.quantidade) * Number(i.valor_unitario), 0);

  return (
    <div>
      <Card>
        <div style={{ marginBottom: 16, borderBottom: `1px solid ${COLORS.border}`, paddingBottom: 14 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <strong style={{ fontSize: 15 }}>Cliente: {pedido.cliente_nome}</strong>
              <Badge tom={STATUS_TOM[pedido.status]}>{STATUS_LABEL[pedido.status]}</Badge>
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <Btn variante="ghost" onClick={onVoltar}>Voltar</Btn>
              {pedido.status === 'enviado_almoxarifado' && !devolvendo && (
                <>
                  <IconBtn titulo="Imprimir Lista de Separação" variante="ghost" onClick={() => imprimir(true)}>
                    <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="6 9 6 2 18 2 18 9" />
                      <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
                      <rect x="6" y="14" width="12" height="8" />
                    </svg>
                  </IconBtn>
                  <Btn variante="danger" onClick={() => setDevolvendo(true)}>Devolver</Btn>
                  <IconBtn titulo="Iniciar Separação" variante="primary" onClick={iniciarSeparacao} disabled={processando}>
                    {processando ? (
                      <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                      </svg>
                    ) : (
                      <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                        <polygon points="5 3 19 12 5 21 5 3" />
                      </svg>
                    )}
                  </IconBtn>
                </>
              )}
              {pedido.status === 'em_separacao' && (
                <>
                  <IconBtn titulo="Imprimir Lista de Separação" variante="ghost" onClick={() => imprimir(false)}>
                    <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="6 9 6 2 18 2 18 9" />
                      <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
                      <rect x="6" y="14" width="12" height="8" />
                    </svg>
                  </IconBtn>
                  <Btn onClick={concluirSeparacao} disabled={processando}>{processando ? 'Concluindo...' : 'Marcar como Separado'}</Btn>
                </>
              )}
              {['aguardando_faturamento', 'devolvido', 'cancelado'].includes(pedido.status) && (
                <IconBtn titulo="Imprimir Lista de Separação" variante="ghost" onClick={() => imprimir(false)}>
                  <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="6 9 6 2 18 2 18 9" />
                    <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
                    <rect x="6" y="14" width="12" height="8" />
                  </svg>
                </IconBtn>
              )}
            </div>
          </div>

          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 18, fontSize: 12, marginTop: 10 }}>
            <div><span style={{ color: COLORS.textLight }}>Nº Pedido:</span> <strong>#{pedido.numero}</strong></div>
            <div><span style={{ color: COLORS.textLight }}>Nº Proposta:</span> <strong>{pedido.proposta_numero ? `#${pedido.proposta_numero}` : '-'}</strong></div>
            <div><span style={{ color: COLORS.textLight }}>Vendedor:</span> <strong>{pedido.vendedor_nome}</strong></div>
            <div><span style={{ color: COLORS.textLight }}>Data:</span> <strong>{new Date(pedido.criado_em).toLocaleDateString('pt-BR')}</strong></div>
            {!['aguardando_faturamento', 'cancelado'].includes(pedido.status) && (() => {
              const dias = diasEmAberto(pedido.criado_em);
              return (
                <div>
                  <span style={{ color: COLORS.textLight }}>Dias em Aberto:</span>{' '}
                  <strong style={{ color: dias >= 2 ? COLORS.danger : (dias >= 1 ? COLORS.warning : COLORS.text) }}>
                    {dias === 0 ? 'Hoje' : `${dias} dia${dias > 1 ? 's' : ''}`}
                  </strong>
                </div>
              );
            })()}
          </div>
        </div>

        {erro && <p style={{ color: COLORS.danger, fontSize: 13 }}>{erro}</p>}

        {devolvendo && (
          <div style={{ background: COLORS.dangerBg, border: `1px solid ${COLORS.danger}40`, borderRadius: 10, padding: 14, marginBottom: 16 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: COLORS.danger, marginBottom: 8 }}>Motivo da Devolução</div>
            <textarea value={motivoDevolucao} onChange={e => setMotivoDevolucao(e.target.value)} rows={3}
              placeholder="Explique o que precisa ser corrigido na proposta antes de reenviar ao almoxarifado..."
              style={{ width: '100%', border: `1.5px solid ${COLORS.border}`, borderRadius: 7, padding: '8px 9px', fontSize: 13, fontFamily: 'inherit', resize: 'vertical', boxSizing: 'border-box' }} />
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 10 }}>
              <Btn variante="ghost" onClick={() => { setDevolvendo(false); setMotivoDevolucao(''); setErro(''); }}>Cancelar</Btn>
              <Btn variante="danger" onClick={confirmarDevolucao} disabled={processando}>{processando ? 'Devolvendo...' : 'Confirmar Devolução'}</Btn>
            </div>
          </div>
        )}

        {pedido.status === 'devolvido' && pedido.observacao_devolucao && (
          <div style={{ background: COLORS.dangerBg, border: `1px solid ${COLORS.danger}40`, borderRadius: 10, padding: 14, marginBottom: 16 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: COLORS.danger, textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 4 }}>
              Motivo da Devolução
            </div>
            <p style={{ margin: 0, fontSize: 13, color: COLORS.text }}>{pedido.observacao_devolucao}</p>
          </div>
        )}

        {pedido.status === 'enviado_almoxarifado' && pedido.observacao_retorno_faturamento && (
          <div style={{ background: COLORS.dangerBg, border: `1px solid ${COLORS.danger}40`, borderRadius: 10, padding: 14, marginBottom: 16 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: COLORS.danger, textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 4 }}>
              Retornado pelo Faturamento
            </div>
            <p style={{ margin: 0, fontSize: 13, color: COLORS.text }}>{pedido.observacao_retorno_faturamento}</p>
          </div>
        )}

        <Secao titulo="Dados do Pedido">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10, fontSize: 13 }}>
            <div><div style={{ color: COLORS.textMid, fontSize: 11 }}>Condição de Pagamento</div>{pedido.condicao_pagamento_nome || '-'}</div>
            <div>
              <div style={{ color: COLORS.textMid, fontSize: 11 }}>Frete</div>
              {pedido.tipo_frete === 'cif' ? `CIF${pedido.entrega_propria ? ' — Entrega Própria' : pedido.transportadora_nome ? ` — ${pedido.transportadora_nome}` : ''}` : 'FOB'}
            </div>
            <div><div style={{ color: COLORS.textMid, fontSize: 11 }}>Nº da Nota Fiscal</div>{pedido.numero_nota_fiscal || '-'}</div>
          </div>
        </Secao>

        <div style={{ height: 14 }} />

        <Secao titulo="Endereço de Entrega">
          <div style={{ fontSize: 13 }}>
            {pedido.entrega_logradouro || '-'}{pedido.entrega_numero ? `, ${pedido.entrega_numero}` : ''}{pedido.entrega_complemento ? ` — ${pedido.entrega_complemento}` : ''}
            {pedido.entrega_bairro ? ` — ${pedido.entrega_bairro}` : ''}{pedido.entrega_cidade ? `, ${pedido.entrega_cidade}` : ''}{pedido.entrega_uf ? `/${pedido.entrega_uf}` : ''}
            {pedido.entrega_cep ? ` — CEP ${pedido.entrega_cep}` : ''}
          </div>
        </Secao>

        <div style={{ height: 14 }} />

        <Secao titulo="Itens a Separar">
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ textAlign: 'left', background: COLORS.bg }}>
                <th style={{ padding: 8 }}>Código</th>
                <th style={{ padding: 8 }}>Cód. Fabricante</th>
                <th style={{ padding: 8 }}>Produto</th>
                <th style={{ padding: 8 }}>Quantidade</th>
                <th style={{ padding: 8 }}>Valor Unit.</th>
                <th style={{ padding: 8 }}>Subtotal</th>
              </tr>
            </thead>
            <tbody>
              {pedido.itens.map(item => (
                <tr key={item.id} style={{ borderTop: `1px solid ${COLORS.border}` }}>
                  <td style={{ padding: 8 }}>{item.produto_codigo}</td>
                  <td style={{ padding: 8 }}>{item.produto_codigo_fabricante || '-'}</td>
                  <td style={{ padding: 8 }}>{item.produto_nome}</td>
                  <td style={{ padding: 8, fontWeight: 700 }}>{item.quantidade}</td>
                  <td style={{ padding: 8 }}>R$ {Number(item.valor_unitario).toFixed(2)}</td>
                  <td style={{ padding: 8 }}>R$ {(Number(item.quantidade) * Number(item.valor_unitario)).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={5} style={{ padding: 8, textAlign: 'right', fontWeight: 700 }}>Total</td>
                <td style={{ padding: 8, fontWeight: 700 }}>R$ {totalGeral.toFixed(2)}</td>
              </tr>
            </tfoot>
          </table>
        </Secao>

        {pedido.observacoes && (
          <>
            <div style={{ height: 14 }} />
            <Secao titulo="Observações">
              <p style={{ fontSize: 13, color: COLORS.text, margin: 0 }}>{pedido.observacoes}</p>
            </Secao>
          </>
        )}
      </Card>
    </div>
  );
}
